import { PagedMultiSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { dataFieldService } from "../api/dataFieldService";

interface Props {
	name: string;
	label: string;
	disabled?: boolean;
	required?: boolean;
}

const fetchConfig = laravelServiceSelectFetchConfig(dataFieldService);

export const DataFieldMultiSelect: FC<Props> = ({ name, label, disabled, required = false }) => {
	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			disabled={disabled}
			fetchConfig={fetchConfig}
			getLabel={(option) => option.label}
			clearable={true}
			required={required}
		/>
	);
};
